export function cleanPhoneNumber(phoneNumber: string): string {
  const digits = phoneNumber?.replace(/\D/g, '');
  return digits.length === 10 ? `+7${digits}` : `+7${digits.slice(-10)}`;
}
